import { connect } from 'react-redux';
import moment from 'moment';

import store from '@tvguide/store';
import { setDetailPanelTarget } from '@store/actions/ux';
import { requestProgramDetails } from '@tvguide/store/actions/requests';
import ProgramsList from './programslist';

const mapStateToProps = (state, ownProps) => {
  let programs = [];

  const targetChan = state.channels.find(c => c.service_id == ownProps.sid);

  if (targetChan && targetChan.programs) {
    programs = targetChan.programs.filter(p => {
      const startTime = moment.utc(p.start_time).add(+state.ux.isDST, 'hour');

      return (
        (startTime.isBetween(
          moment
            .utc(state.ux.displayedTime.start)
            .subtract(2, 'hours')
            .add(+state.ux.isDST, 'hour'),
          moment
            .utc(state.ux.displayedTime.end)
            .add(+state.ux.isDST, 'hour')
            .add(1, 'hour'),
          [],
        ) ||
          startTime
            .add(moment.duration(p.duration).asSeconds(), 'seconds')
            .isBetween(
              moment
                .utc(state.ux.displayedTime.start)
                .subtract(2, 'hours')
                .add(+state.ux.isDST, 'hour'),
              moment
                .utc(state.ux.displayedTime.end)
                .add(+state.ux.isDST, 'hour')
                .add(1, 'hour'),
              [],
            )) &&
        p.start_time
      );
    });
  }

  return {
    programs: programs,
    minutesPixelRatio: state.ux.minutesPixelRatio,
    detailPanelProgramId: state.ux.detailPanel.id,
    beginDate: state.ux.beginDate,
    isDST: state.ux.isDST,
    accessibility: state.ux.accessibilities,
    highlights: state.ux.highlights.filter(el => el.value),
  };
};

const mapDispatchToProps = dispatch => ({
  displayProgramDetails: (sid, id, pid) => {
    const nid = store.getState().ux.nid;
    const targetChan = store.getState().channels.find(c => c.service_id == sid);
    const targetProg = targetChan.programs.find(p => p.program_id == pid);

    dispatch(setDetailPanelTarget(id));
    dispatch(
      requestProgramDetails(
        sid,
        nid,
        id,
        pid,
        encodeURIComponent(targetProg.start_time),
        targetProg.duration,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramsList);
